export enum RecommendationTarget {
  DEFICIT = 1,
  STRENGTH = 2,
}
